<template>
  <el-drawer
    title="Cambio de fecha de pago"
    :append-to-body="true"
    :visible.sync="visible"
    size="25%"
    @close="cancel"
    @opened="opened"
  >
    <el-container>
      <el-main>
        <el-row>
          <el-col>
            <el-form
              ref="form"
              label-width="120px"
              v-model="form"
              v-loading="loading"
            >
              <el-form-item label-width="0">
                <el-date-picker
                  type="date"
                  placeholder="Fecha Original"
                  v-model="form.PostingDate"
                  disabled
                  style="width: 100%"
                ></el-date-picker>
              </el-form-item>

              <el-form-item label-width="0">
                <el-date-picker
                  type="date"
                  placeholder="Nueva Fecha"
                  v-model="form.NewPostingDate"
                  style="width: 100%"
                ></el-date-picker>
              </el-form-item>

              <el-form-item label-width="0">
                <el-input
                  type="number"
                  placeholder="Monto"
                  v-model="form.Amount"
                  style="width: 100%"
                ></el-input>
              </el-form-item>

              <el-form-item label-width="0">
                <el-button type="primary" @click="submit" size="mini"
                  >Guardar cambios</el-button
                >
                <el-button @click="cancel" size="mini">Cancelar</el-button>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
  </el-drawer>
</template>

<script>
export default {
  name: "ChangePostingDateAndAmount",
  events: ["success", "error"],
  data() {
    return {
      loading: true,
      visible: false,
      form: {
        Type: 0,
        LookingForward: false,
        Created: "",
        Id: 0,
        RowCashFlow: null,
        CurrentRowId: 0,
        AccountNumber: "",
        AccountName: "",
        DocumentNumber: "",
        PostingDate: "",
        NewPostingDate: "",
        Amount: 0,
        Executed: false
      }
    };
  },
  methods: {
    show(data) {
      this.visible = true;
      this.form = data;
    },
    submit() {
      this.loading = true;
      this.$http
        .post("/api/CashFlow/UpdatePostingDate", {
          AccoundRowID: this.form.Id,
          PostingDate: this.form.NewPostingDate,
          Amount: this.form.Amount
        })
        .then(() => {
          this.$notify.success({
            duration: 2000,
            message: "Registro de la cuenta actualizada",
            title: "Información",
            position: "top-left"
          });
          this.$emit("success");
        })
        .catch((error) => {
          this.$message.error("Error al consultar los Registros");
          console.error(error);
          this.cancel();
          this.$emit("error");
        })
        .finally(() => {
          this.loading = false;
          this.cancel();
        });
    },
    cancel() {
      this.visible = false;
      this.loading = true;
      this.form = {
        Type: 0,
        LookingForward: false,
        Created: "",
        Id: 0,
        RowCashFlow: null,
        CurrentRowId: 0,
        AccountNumber: "",
        AccountName: "",
        DocumentNumber: "",
        PostingDate: "",
        NewPostingDate: "",
        Amount: 0,
        Executed: false
      };
    },
    opened() {
      this.loading = false;
    }
  }
};
</script>
